<template>
  <div class="calendar-options-style">
    <local-style
      class="template-styles"
      :options="options"
      :container_id="ids.container_id"
      :rect_id="ids.rect_id"
      elementType="cxCalendar"
      :styleImgs="styleImgs"
      ref="localStyleComponent"
    />
  </div>
</template>

<script>
import localStyle from "toolbarComponents/styles/local-style.vue"
export default {
  name: "calendar-options-style",
  components: { localStyle },
  props: {
    options: Object
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  },
  data() {
    return {
      styleImgs: [
        require("assets/images/leftMenu/calendar/style1.png"),
        require("assets/images/leftMenu/calendar/style2.png"),
        require("assets/images/leftMenu/calendar/style3.png")
      ]
    }
  },
  mounted() {
    if(this.request_prefix === "appStage"){
      this.styleImgs.splice(1,1)
    }
  },
  methods: {}
}
</script>
